export const routes = {
  myCalls: '/my_calls',
  signIn: '/users/sign_in',
  signUp: '/users/sign_up',
  confirmPersonalEmail: '/users/sign_up/confirm-personal-email',
}
